import { render, staticRenderFns } from "./AiBookSubShelvesManage.vue?vue&type=template&id=107f8d70&scoped=true"
import script from "./AiBookSubShelvesManage.vue?vue&type=script&lang=js"
export * from "./AiBookSubShelvesManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "107f8d70",
  null
  
)

export default component.exports